import Project1 from "../../assets/Project1.png";
import Project2 from "../../assets/Project2.png";
import Project3 from "../../assets/Project3.png";
import Project4 from "../../assets/Project4.png";
import Project5 from "../../assets/Project5.png";
import Project6 from "../../assets/Project6.png";
import Project7 from "../../assets/Project7.png";
import Project8 from "../../assets/Project8.png";
import Project9 from "../../assets/Project9.png";
import Project10 from "../../assets/Project10.png";
import Project11 from "../../assets/Project11.png";
import Project12 from "../../assets/Project12.png";

export const projects_list = [
  {
    id: 1,
    image: Project1,
    title: "Chat App",
    techstack: "HTML, CSS, Javascript, ReactJs, Socket.io, Ant-Icons",
    github: "https://github.com/Vishalsingh061/Chat-App",
    demo: "https://chatappprojectvishalsingh.netlify.app/",
  },
  {
    id: 2,
    image: Project2,
    title: "Netflix Clone ",
    techstack: "HTML, CSS, ReactJs, The Movie data API",
    github: "https://github.com/Vishalsingh061/React-App-of-Netflix-Clone",
    demo: "https://netflixcloneprojectbyvishalsingh.netlify.app/",
  },
  {
    id: 3,
    image: Project3,
    title: "Ecommerce Website",
    techstack: "ReactJs, Javascript, Html, Sass, Material UI",
    github: "https://github.com/Vishalsingh061/ecommerce-website",
    demo: "https://ecommercesitebyvishalsingh.netlify.app/",
  },
  {
    id: 4,
    image: Project4,
    title: "Social Media",
    techstack: "Html, Css, JavaScript, ReactJS, MongoDB, NodeJs, ExpressJs",
    github: "https://github.com/Vishalsingh061/social-media-project",
    demo: "https://socialmediappproject.netlify.app/",
  },
  {
    id: 5,
    image: Project5,
    title: "Restaurant Website",
    techstack: "Html, Css, JavaScript",
    github: "https://github.com/Vishalsingh061/Responsive-Restaurant-Website-Using-Html-Css",
    demo: "https://restaurantwebsiteresponsive.netlify.app/",
  },
  {
    id: 6,
    image: Project6,
    title: "Travel Website",
    techstack: "Html, Css",
    github: "https://github.com/Vishalsingh061/Responsive-Travel-Website-Using-Float",
    demo: "https://travelwebsiteusingfloat.netlify.app/",
  },
  {
    id: 7,
    image: Project7,
    title: "My Portfolio",
    techstack: "Html, Css, Javascript, ReactJS",
    github: "https://github.com/Vishalsingh061/My-PortFolio",
    demo: "https://portfolioofvishal.netlify.app/",
  },
  {
    id: 8,
    image: Project8,
    title: "Employee Management System",
    techstack: "Html,Javascript, ReactJS, Redux, TailwindCSS",
    github: "https://github.com/Vishalsingh061/Employee-Management-System",
    demo: "https://employee-management-system-project.netlify.app/",
  },
  {
    id: 9,
    image: Project9,
    title: "MERN Task Manager",
    techstack: "Html, Css, Javascript, ReactJS, MongoDB, Node.Js, Express.Js, Redux-toolkit",
    github: "https://github.com/Vishalsingh061/task-mern-backend",
    demo: "https://task-mern-frontend-vert.vercel.app/login",
  },
  {
    id: 10,
    image: Project10,
    title: "MERN Connectify Social Media App",
    techstack: "Html, Css, Javascript, ReactJS, MongoDB, Node.Js, Express.Js, Redux-toolkit",
    github: "https://github.com/Vishalsingh061/Mern-Connectify-Social-Media-Project",
    demo: "https://mern-connectify-social-media-project.vercel.app/login",
  },
  {
    id: 11,
    image: Project11,
    title: "Animated Education Website",
    techstack: "Html, Css, Javascript, ReactJs",
    github: "https://github.com/Vishalsingh061/Animated-Education-Website",
    demo: "https://vishaleduhub.netlify.app/",
  },
  {
    id: 12,
    image: Project12,
    title: "MERN Ecommerce Website",
    techstack: "Html, Css, Javascript, ReactJs, MongoDB, NodeJs, ExpressJs, Redux-toolkit",
    github: "https://github.com/Vishalsingh061/mern-Commerce-frontend-code",
    demo: "https://mern-commerce-frontend-code.vercel.app/",
  },
]